module.exports = __webpack_public_path__ + "static/media/blog.79c395c4.jpg";